module.exports = __webpack_public_path__ + "img/hr_school_flow.d521fafa.png";